// @flow
import React, { Component, type Node } from 'react';
import styled from 'styled-components';


type BlockquoteProps = {
    /** not required, but consider using an enclosing p tag */
    children: Node,
    footer?: string
}

const StyledBlockquote = styled.blockquote`
    margin-bottom: 2rem;
    footer {
        margin-top: 2rem;
    }
`;


/** A component for a blockquote. */
export class Blockquote extends Component<BlockquoteProps> {

    render() {
        const footer = this.props.footer;

        return (
            <StyledBlockquote className='blockquote'>
                {this.props.children}
                {footer ? <footer className="blockquote-footer">{footer}</footer> : null}
            </StyledBlockquote>
        );
    }
}

export default Blockquote;
